import React from 'react'
import { useScreenSubscription } from '../subscription/screenProviderLocationAccount';
import { PaymentMethodEditBase } from './paymentMethodEditBase';

export const PaymentMethodEditDynamic = () => {
    const { goBack, selectedCard } = useScreenSubscription();
    
    return (
        <PaymentMethodEditBase 
            title={''} 
            goBack={goBack}
            card={selectedCard}
        />
    );
}
